import { http, baseUrlOnboarding } from './_http';
import { logWebHrError } from '@/core/logger/log-wrapper';

export async function getDocSignatureURL(tenantId, signatureId) {
  try {
    const result = await http.get(
      `${baseUrlOnboarding}/docsignature/requests/${tenantId}/${signatureId}`
    );

    if (!result || !result.data || !result.data.data) {
      return {};
    }

    return result.data.data;
  } catch (e) {
    logWebHrError({
      message: 'getDocSignatureURL failed',
      source: 'document-signature',
      metadata: { tenantId, signatureId },
      error: e,
    });

    return {}; // TODO: remove this after fixing the backend svc

    // eslint-disable-next-line no-unreachable
    if (e && e.response && e.response.error && e.response.error.message) {
      throw new Error(e.response.error.message);
    }

    throw new Error(e);
  }
}

export async function updateSignedStatus({
  onboardingId,
  documentId,
  fieldId,
  signed,
}) {
  const result = await http.post(
    `${baseUrlOnboarding}/${onboardingId}/documents/${documentId}/fields/${fieldId}:update-signed-info`,
    {
      signed,
    }
  );

  if (!result || !result.data || !result.data.data) {
    return {};
  }

  return result.data.data;
}

export default {
  getDocSignatureURL,
};
